import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { refreshAccessToken } from '@/lib/api/client'

// Keep the session alive proactively so the login doesn't expire mid-use:
//  - refresh the access token on a heartbeat (well under its lifetime), and
//  - refresh whenever the tab becomes visible again (after the laptop sleeps / long idle).
// The refresh token (long-lived) is exchanged for a fresh access token; if it has truly expired,
// the client's 401 handling forces a clean re-login.
const HEARTBEAT_MS = 30 * 60 * 1000 // 30 minutes

export function useSessionKeepAlive() {
  useEffect(() => {
    const refresh = () => {
      const s = useAuthStore.getState()
      if (s.status === 'authenticated' && s.getRefreshToken()) {
        void refreshAccessToken().catch(() => {
          /* 401 handling / AuthGuard will surface a re-login if the refresh token is gone */
        })
      }
    }
    const id = window.setInterval(refresh, HEARTBEAT_MS)
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])
}
